import { render } from "./course-set.vue?vue&type=template&id=0e35ff9f&scoped=true&ts=true"
import script from "./course-set.vue?vue&type=script&lang=ts"
export * from "./course-set.vue?vue&type=script&lang=ts"

import "./course-set.vue?vue&type=style&index=0&id=0e35ff9f&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e35ff9f"]])

export default __exports__